/* FB | Sepet erken + KALICI gorunum fix v7 (KOF + Hediye Paketi) + KOF nokta blink faz korumasi + DUSUK YUK.
   Mevcut bolumlere/morph'a DOKUNMAZ. Tamamen additive.
   v7: Her morph mutasyonunda OLAY TETIKLEMEYI BIRAKTIK (gift-wrap fetch + yeniden render zinciri -> yuk/donma riski).
   Morph sirasinda yalnizca KOF dogrudan geri konur + nokta fazi (fb-kof-dot-blink 1.8s !important) korunur (ucuz, dispatch yok).
   Olay tetikleme sadece acilis/tiklama aninda, sinirli. Hediye paketi kendi cart:update'iyle gelir. */
(function(){
  'use strict';
  if(window.__fbKofEager) return; window.__fbKofEager=true;
  function nowMs(){ try{ return (window.performance&&performance.now)?performance.now():Date.now(); }catch(e){ return Date.now(); } }
  var DOT_PERIOD=1.8; /* fb-lora-font.css ile birebir */

  function tuneKof(kof){
    try{
      if(!kof || kof.getAttribute('data-fb-tuned')==='1') return;
      if(window.__fbKofT0==null) window.__fbKofT0=nowMs();
      var elapsed=(nowMs()-window.__fbKofT0)/1000;
      var dot=kof.querySelector('.fb-kof__dot');
      if(dot) dot.style.setProperty('animation-delay','-'+(elapsed%DOT_PERIOD).toFixed(3)+'s','important');
      kof.setAttribute('data-fb-tuned','1');
    }catch(e){}
  }
  function tuneAny(){ try{ var l=document.querySelectorAll('cart-drawer-component dialog[open] .fb-kof[data-fb-kof]'); for(var i=0;i<l.length;i++) tuneKof(l[i]); }catch(e){} }

  function injectKof(dialog){
    try{
      if(!dialog || !dialog.hasAttribute('open')) return;
      if(dialog.querySelector('[data-fb-kof]')) return;
      var summary=dialog.querySelector('.cart-drawer__summary');
      if(!summary || !summary.parentNode) return;
      var tpl=document.getElementById('fb-cart-upsell-template');
      if(!tpl || !tpl.content) return;
      var frag=tpl.content.cloneNode(true);
      var kof=frag.querySelector('[data-fb-kof]');
      /* FB KOF SCROLL FIX: mobilde KOF'u drawer'in TEK dikey scroller'i olan
         .cart-drawer__items icine (en sona) koy -> dikey swipe panel uzerinde de calisir.
         PC'de eski konum (summary ustu) aynen korunur. Bos sepette items'a dokunulmaz. */
      var fbItems=dialog.querySelector('.cart-drawer__items:not(.fb-empty-cart-items)');
      var fbMobile=false;
      try{ fbMobile=window.matchMedia('(max-width: 749px)').matches; }catch(e){}
      if(fbMobile && fbItems){ fbItems.appendChild(frag); }
      else { summary.parentNode.insertBefore(frag, summary); }
      if(kof) tuneKof(kof);
    }catch(e){}
  }
  function injectKofAll(){ try{ var ds=document.querySelectorAll('cart-drawer-component dialog'); for(var i=0;i<ds.length;i++) injectKof(ds[i]); }catch(e){} }

  /* ucuz: morph sirasinda KOF geri koy + nokta fazini ayarla. DISPATCH YOK. */
  function applyNow(){ injectKofAll(); tuneAny(); }

  function giftMissing(){ try{ if(!window.__fbGiftWrap) return false; var ds=document.querySelectorAll('cart-drawer-component dialog[open]'); for(var i=0;i<ds.length;i++){ var sum=ds[i].querySelector('.cart-drawer__summary'); if(sum && !sum.querySelector('.fb-gw-sumbtn')) return true; } }catch(e){} return false; }
  /* olay tetikleme yalnizca burada (acilis/tiklama), morph'ta DEGIL */
  function kick(){ applyNow(); if(giftMissing()){ try{ document.dispatchEvent(new CustomEvent('fb:cart-drawer-render-fixed')); }catch(e){} } }

  var pending=false;
  function schedule(){ if(pending) return; pending=true; var run=function(){ pending=false; applyNow(); }; try{ requestAnimationFrame(run); }catch(e){ run(); } }

  function watch(){
    try{
      var ds=document.querySelectorAll('cart-drawer-component dialog');
      for(var i=0;i<ds.length;i++){
        (function(d){
          if(d.__fbKofEagerWatch) return; d.__fbKofEagerWatch=true;
          d.__fbWasOpen=d.hasAttribute('open');
          try{ new MutationObserver(function(){
            var openNow=d.hasAttribute('open');
            if(openNow && !d.__fbWasOpen){ window.__fbKofT0=null; kick(); }
            d.__fbWasOpen=openNow;
            schedule();
          }).observe(d,{attributes:true,attributeFilter:['open'],childList:true,subtree:true}); }catch(e){}
          if(d.hasAttribute('open')){ kick(); }
        })(ds[i]);
      }
    }catch(e){}
  }

  function boot(){
    watch(); kick();
    document.addEventListener('fb:cart-drawer-render-fixed', tuneAny);
    /* FB TIKLAMA HIZI FIX (2026-06-11): 'cart-drawer-component' seciciden CIKARILDI.
       Drawer ICINDEKI her tiklamada (adet +/-, KOF toggle) kick+120ms+400ms dalgalari calisip
       zorla-reflow yaratiyordu -> tiklamalar ~0.3sn gec hissediliyordu. Acilis/morph guvenligi
       open-observer + childList-observer + acilis interval'inde AYNEN duruyor. */
    document.addEventListener('click', function(e){ var t=e.target&&e.target.closest&&e.target.closest('a[href*="/cart"], .header-actions__cart-icon, [data-cart-toggle]'); if(t){ kick(); setTimeout(kick,120); setTimeout(applyNow,400); } }, true);
    var tries=0; var iv=setInterval(function(){ tries++; watch(); applyNow(); if(giftMissing()) kick(); if(tries>18) clearInterval(iv); }, 450);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
